import React from 'react';
import { PropTypes } from 'prop-types';
import { push } from 'react-router-redux';
import { toast } from 'react-toastify';

import { CRUD } from './queries';
import I18N from '../../common/i18n';
import { withApolloAsyncLoad } from '../../../base/utils';
import { store } from '../../..';
import { AppSections, Sections } from '../../common/enums';
import UserForm from './UserForm';

export default
class UserEdit extends React.PureComponent {
  static title = I18N.USERS_EDIT_TITLE

  static propTypes = {
    itemId: PropTypes.number.isRequired,
  }

  _update = (update, data) => {
    const p = update({
      variables: {
        id: this.props.itemId,
        data: data
      }
    });
    p.then((res) => {
      toast.success(`${I18N.USERS_EDIT_TITLE}. ${I18N.NOTIFY_SUCCESS}`);
      store.dispatch(push(`/${AppSections.CATALOG}/${Sections.USERS}`));
    });
    p.catch((res) => {
      toast.error(`${I18N.USERS_EDIT_TITLE}. ${I18N.NOTIFY_ERROR}`);
      console.log('update error');
    });
    return p;
  }

  _renderForm = (user) => (
    CRUD.UPDATE(
      {},
      (update) => (
        <UserForm
          {...this.props}
          key={user.id}
          submitText={I18N.SUBMIT_SAVE}
          item={user}
          submit={(data) => this._update(update, data)} />
      )
    )
  );

  render() {
    return (
      CRUD.GET_ONE(
        {id: this.props.itemId},
        (result) => withApolloAsyncLoad(this._renderForm, result)
      )
    );
  }
}
